import client from '../client'

export const getUserDetailsKey = `${process.env.NEXT_PUBLIC_ACCOUNT_DOMAIN}/${process.env.NEXT_PUBLIC_IDENTITY_VERSION}/user/getdetails`

export async function getUserDetails() {
  return client(getUserDetailsKey)
}
